<template>
  <div class="home">
    <div class="pagewrapper_home">
      <div class="leftCol_home">
        <div class="logo-box">
          <img :src="require('../assets/images/logo@2x.png')" />
          <h3>{{$t('star')}}</h3>
        </div>
      </div>
      <div class="rightCol_home">
        <Login />
      </div>
    </div>
  </div>
</template>
<script>
import Login from "../components/Login";
export default {
  name: "home",
  components: {
    Login
  },

  data() {
    return {};
  }
  ,
  methods:{
       changeLocale(locale) {
      if (["tl", "ta"].includes(this.$cookie.get("lang"))) {
        document.querySelector("body").classList.add("activeMultiLang");
      }
      this.$i18n.locale =
        this.$cookie.get("lang") || document.URL.split("=")[1] || "hi";
    }

  },
  mounted(){
    this.changeLocale();

  }
};
</script>
<style>
</style>


